import { render } from "./Ma_NtabiTossPayResult.vue?vue&type=template&id=11cccd61&scoped=true"
import script from "./Ma_NtabiTossPayResult.vue?vue&type=script&lang=js"
export * from "./Ma_NtabiTossPayResult.vue?vue&type=script&lang=js"

import "./Ma_NtabiTossPayResult.vue?vue&type=style&index=0&id=11cccd61&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11cccd61"]])

export default __exports__